<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary">
            دریافت خروجی اکسل تراکنش ها بر اساس کاربر
        </a-button>

        <a-modal width="1000px" v-model="visible" title="    دریافت خروجی اکسل    " on-ok="handleOk">
            <div class="row">
                <div class="col-md-6 ">
                    </div>
                <div class="col-md-6 ">
                    <label class="sr-only" for="inline-form-input-name">  شناسه کاربر</label>
                    <input class="form-control" type="text" v-model="info.user_id">
                </div>
               
            </div>
            <template slot="footer">
                <a-button :disabled="loading" @click="validate()">
                    <a-icon type="upload" /> خروجی اکسل
                </a-button>
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>
            </template>



        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            answers: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                info: {}
            };
        },
        methods: {
            async validate() {
                if (this.info.user_id == undefined) {
                    this.$toast.error("لطفا شناسه کاربر را وارد کنید.");
                } else {
                    let url =
                        `${this.$store.state.baseUrl}/transactions/user-report?user_id=${this.info.user_id}`
                    let _this = this;
                    this.loading=true;
                    await axios
                        .get(url)
                        .then(function(response) {
                            if (response.data.data === true) {
                                _this.loading=false;
                                _this.$toast.success('گزارش باموفقیت ثبت شد و در حال پردازش می باشد.');
                            }
                            _this.visible = false;
                            _this.$emit('getData')

                        })
                        .catch(function(err) {
                            _this.loading=false;
                            _this.$root.handleAxiosError(err);
                        });
                }
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')

            },

        },
    };
</script>
